import React from 'react';
import { createRoot } from 'react-dom/client';
import Countdown from 'react-countdown';
import Translate from '@components/translation/translate-text-wrapper';
import { getDrupalDateTime } from '@services/date-services';

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return;
  } else {
    return (
      <time className="simple-countdown-timer">
        <div className="countdown-number">
          <div className="count-type">
            <Translate useJson={false}>Days</Translate>
          </div>
          <div className="days">{days}</div>
        </div>
        <div className="countdown-number">
          <div className="count-type">
            <Translate useJson={false}>Hours</Translate>
          </div>
          <div className="hours">{hours}</div>
        </div>
        <div className="countdown-number">
          <div className="count-type">
            <Translate useJson={false}>Minutes</Translate>
          </div>
          <div className="minutes">{minutes}</div>
        </div>
        <div className="countdown-number">
          <div className="count-type">
            <Translate useJson={false}>Seconds</Translate>
          </div>
          <div className="seconds">{seconds}</div>
        </div>
      </time>
    );
  }
};

export const simpleCountdownTimer = () => {
  const simpleTimers = document.querySelectorAll('.simple-countdown-timer');
  if (simpleTimers.length > 0) {
    simpleTimers.forEach((timer) => {
      const targetDate = timer.getAttribute('data-target-date');
      const root = createRoot(timer);
      if (targetDate) {
        root.render(
          <Countdown
            date={getDrupalDateTime(targetDate || '')}
            renderer={renderer}
          />
        );
      }
    });
  }
};
